import { Drawer } from 'antd';
import type React from 'react';
import { RiCloseFill } from 'react-icons/ri';
import MenuLogo from '../logo';
import Menu from '../menu';
import styles from './MenuMobile.module.css';

interface MenuMobileProps {
  onClose?: () => void;
  visible?: boolean;
}

const MenuMobile: React.FC<MenuMobileProps> = ({ onClose = () => {}, visible = false }) => {
  return (
    <Drawer
      title={<MenuLogo closeHandler={onClose} isMobile />}
      size={256}
      placement="left"
      closable={{ placement: 'end' }}
      onClose={onClose}
      open={visible}
      closeIcon={<RiCloseFill className="remix-icon hp-text-color-black-80" size={20} />}
      className={styles.wrapper}
    >
      <Menu onClose={onClose} />
    </Drawer>
  );
};

export default MenuMobile;
